import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/footer.css";
import "../css/legal.css";

const Footer = () => {
  const [doNotSellDone, setDoNotSellDone] = useState(false);

  const handleDoNotSell = () => {
    localStorage.setItem("cla_cookie_consent", "essential");
    setDoNotSellDone(true);
  };

  return (
    <div className="container f-p">
      <div className="footer-parent">
        <div className="footer">
          <div className="footer-left">
            <div className="footer-left-img">
              <img src="/assets/footer-left-img.png" alt="" />
            </div>
            <div className="our-locations">
              <h2>Our Locations</h2>
              <img src="/assets/locations-map.png" alt="locations" />
            </div>
          </div>

          <div className="footer-right">
            <div className="company-info">
              <a
                href="https://www.linkedin.com/company/continental-lease-advisors/"
                rel="noopener noreferrer"
                target="_blank"
                aria-label="Continental Lease Advisors on LinkedIn (opens in new tab)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  data-supported-dps="24x24"
                  fill="currentColor"
                  className="mercado-match"
                  width="24"
                  height="24"
                  focusable="false"
                  aria-hidden="true"
                >
                  <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"></path>
                </svg>
              </a>
              <span className="company-info-text">
                Continental Lease Advisors LLC (“CLA”) is a Chicago-based
                specialized lease and financial due diligence company, with
                additional personnel locations in Phoenix, AZ, Denver, CO, and
                Dallas, TX.
              </span>
              <div className="logo-footer">
                <img
                  src="/assets/logo-footer.png"
                  alt="Continental Lease Advisors Logo"
                />
              </div>
            </div>

            <img src="/assets/footer-design-element.png" alt="" />
          </div>
        </div>
        <div className="company-copyright-container">
          <nav className="footer-legal-links" aria-label="Legal">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="footer-legal-sep" aria-hidden="true">|</span>
            <Link to="/terms">Terms &amp; Conditions</Link>
            <span className="footer-legal-sep" aria-hidden="true">|</span>
            <Link to="/accessibility">Accessibility</Link>
            <span className="footer-legal-sep" aria-hidden="true">|</span>
            <button className="do-not-sell-btn" onClick={handleDoNotSell}>
              Do Not Sell or Share My Personal Information
            </button>
          </nav>
          {doNotSellDone && (
            <span className="do-not-sell-confirmed" role="status">
              Opt-out saved — non-essential data sharing has been disabled.
            </span>
          )}
          <p className="company-copyright">
            Copyright © {new Date().getFullYear()} Continental Lease Advisors
            LLC
            <br />
            Powered By{" "}
            <a
              href="https://www.valexity.com/"
              target="_blank"
              rel="noreferrer"
            >
              {" "}
              Valexity Technologies
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
